// SPDX-License-Identifier: GPL-3.0-or-later

export const coverTemplate = String.raw`#set page(paper: "a4", margin: 2.5cm)
#set text(font: "Libertinus Serif", size: 11pt)
#set par(justify: true, leading: 0.7em, first-line-indent: 0pt, spacing: 1em)

*{{applicant.fullName}}* \
{{applicant.email}}{{#applicant.phone}} #sym.dot.c {{applicant.phone}}{{/applicant.phone}}{{#applicant.location}} \
{{applicant.location}}{{/applicant.location}}

#v(1.5em)

{{date}}

#v(1.5em)

{{#recipient.name}}{{recipient.name}} \ {{/recipient.name}}{{#recipient.title}}{{recipient.title}} \ {{/recipient.title}}{{recipient.company}}{{#recipient.address}} \
{{recipient.address}}{{/recipient.address}}

#v(2em)

{{greeting}}

#v(0.5em)

{{#paragraphs}}
{{.}}

{{/paragraphs}}

#v(0.5em)

{{signoff}} \
_{{applicant.fullName}}_
`;
